module.exports = __webpack_public_path__ + "img/IMG-20200623-WA0023.a3083939.jpg";